import { FC } from "react";

import Colors from "@constants/Colors";

interface VectorProps {
  color?: string;
}

const Vector: FC<VectorProps> = ({ color }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 10H17L14 19L8 1L5 10H1"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

Vector.defaultProps = {
  color: Colors.neutralblack,
};

export default Vector;
